/**
 * @generated SignedSource<<51e9c04d5261b2907e7ca044f37d2ccf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SendNotesModal_Timing_note$data = {
  readonly eventEnd: string | null;
  readonly eventStart: string | null;
  readonly eventTitle: string | null;
  readonly noteTitle: string;
  readonly " $fragmentType": "SendNotesModal_Timing_note";
};
export type SendNotesModal_Timing_note$key = {
  readonly " $data"?: SendNotesModal_Timing_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"SendNotesModal_Timing_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SendNotesModal_Timing_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventTitle",
      "storageKey": null
    },
    {
      "alias": "noteTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "bac78f18c5eeefeea52e211c851dfcf6";

export default node;
